import React, { useState, useEffect } from 'react'
import { selectors as OrganizationSelectors } from 'data/organizations'
import { connect } from 'react-redux'
import Select from 'components/base/Select'
import { CalendarIcon } from 'components/Utils/Icons'
import Popular from './sections/Popular'
import TeamActivity from './sections/TeamActivity'
import SearchAnalytics from './sections/Search'
import Paywall from './components/Paywall'
import { trackNavigateToInsights as trackNavigateToInsightsAction } from 'data/analytics/actions'

const ANALYTICS_PERIOD = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  ALL_TIME: 'ALL_TIME',
}

const TEXT_BY_PERIOD = {
  [ANALYTICS_PERIOD.WEEK]: 'Last 7 days',
  [ANALYTICS_PERIOD.MONTH]: 'Last month',
  [ANALYTICS_PERIOD.ALL_TIME]: 'All time',
}

function Analytics({ isFreeOrganization, trackNavigateToInsights }) {
  const [selectedPeriod, setAnalyticsPeriod] = useState(ANALYTICS_PERIOD.WEEK)
  useEffect(
    () => {
      trackNavigateToInsights()
    },
    // ! Let's track the event only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (isFreeOrganization) {
    return <Paywall />
  }

  return (
    <section className="analytics">
      <div className="flexbox flexbox-justify-end margin-bottom-largest">
        <Select
          value={selectedPeriod}
          onChange={setAnalyticsPeriod}
          options={Object.keys(ANALYTICS_PERIOD).map(periodOption => {
            return {
              key: periodOption,
              title: (
                <div className="flexbox shade-20 font-weight-medium">
                  <CalendarIcon className="margin-right-normal" size={16} />{' '}
                  {TEXT_BY_PERIOD[periodOption]}
                </div>
              ),
              value: periodOption,
            }
          })}
        />
      </div>

      <div className="flexbox flexbox-space-between margin-bottom-huge">
        <Popular period={selectedPeriod} />
        <TeamActivity period={selectedPeriod} />
      </div>
      <div className="flexbox flexbox-space-between margin-bottom-huge">
        <SearchAnalytics period={selectedPeriod} />
      </div>
    </section>
  )
}

export default connect(
  state => {
    return { isFreeOrganization: OrganizationSelectors.isFree(state) }
  },
  { trackNavigateToInsights: trackNavigateToInsightsAction }
)(Analytics)
